export function deleteUrlParam(param, history) {
  const currentUrlParams = new URLSearchParams(window.location.search);
  currentUrlParams.delete("idAnexo");

  history.replace({
    pathname: window.location.pathname,
    search: currentUrlParams.toString(),
  });
}